import axios, { AxiosError } from "axios";

export class InvalidURLError extends Error {
  constructor(url: string) {
    super(`Invalid URL: ${url}`);
  }
}

export function assertIsAxiosError(error: unknown): asserts error is AxiosError {
  if (!axios.isAxiosError(error)) {
    console.error(error);
    throw new Error(`A non-network-related error occurred: ${error}`);
  }
}
